import styled, { css } from 'styled-components';
import { appTheme, pitchTheme } from '../styles/theme';

export type BrandWordmarkVariant = 'header' | 'slide';

const variantStyles = ($variant: BrandWordmarkVariant) =>
  $variant === 'slide'
    ? css`
        font-size: clamp(0.875rem, 2vw, 1.0625rem);
      `
    : css`
        font-size: 1.25rem;
      `;

/** Text wordmark for app chrome and slide logo slots. */
const BrandWordmark = styled.span<{ $variant?: BrandWordmarkVariant }>`
  display: block;
  font-family: ${pitchTheme.fontUi};
  font-weight: 700;
  letter-spacing: -0.03em;
  color: ${appTheme.text};
  line-height: 1;
  white-space: nowrap;
  user-select: none;
  ${({ $variant = 'header' }) => variantStyles($variant)}
`;

export default BrandWordmark;
